import { userIsAuthenticatedRedir } from 'services/authHoc';

import RoleRoutes from './AuthorizedRoutes';

export default userIsAuthenticatedRedir(RoleRoutes);
